

























































import Vue, { PropType } from "vue";
import DoughnutChart from "@/features/home/components/doughnutChart.vue";
import NoData from "@/features/home/components/noData.vue";
import { DemandSales, DemandSalesTable } from "@/features/home/types";
import { getColorCodeList, getChartColorEnum } from "@/features/home/utils";
import { round } from "@/features/home/utils";
import { getCurrencySign } from "@/commons/utils/currencySign";

export default Vue.extend({
  components: {
    "doughnut-chart": DoughnutChart,
    "no-data": NoData,
  },

  props: {
    loading: { type: Boolean, required: true },
    isNoData: { type: Boolean, required: true },
    chartData: {
      type: Object as PropType<DemandSales>,
      required: true,
    },
    tableData: {
      type: Array as PropType<DemandSalesTable[]>,
      required: true,
    },
  },

  data() {
    return {
      colorList: getColorCodeList() as string[],
    };
  },

  methods: {
    roundNumber(value: number): number {
      return round(value);
    },
    hoverVendorList(index: number) {
      this.colorList = getColorCodeList();
      if (getChartColorEnum(index) !== undefined) {
        (this as any).colorList[index] = getChartColorEnum(index)?.highlightColorCode;
      }
    },
    leaveVendorList() {
      this.colorList = getColorCodeList();
    },
    columnColor(index: number): string | undefined {
      if (getChartColorEnum(index) !== undefined) {
        return getChartColorEnum(index)?.colorName;
      }
    },
    getCurrencySign(): string {
      return getCurrencySign();
    },
  },
});
